import styled from 'styled-components'

import { helpers } from '../../../../../styles/theme'

type Props = {
	isActive: boolean
	isSmall: boolean
	hasError: boolean
}

export const Container = styled.div<Props>`
	display: flex;
	align-items: center;
	justify-content: center;
	height: ${({ isSmall }) => (isSmall ? 'calc(100% - 24px)' : 'calc(100% - 12px)')};
	margin: ${({ isSmall }) => (isSmall ? '0 0 0 6px' : '0')};
	padding: ${({ isSmall }) => (isSmall ? ' 0 6px 2px 5px' : '0 10px')};
	color: ${({ isActive, hasError }) => {
		if (hasError)
			return isActive ? helpers.color.input.menuIndicatorErrorActive : helpers.color.input.menuIndicatorError
		return isActive ? helpers.color.input.menuIndicatorActive : helpers.color.input.menuIndicator
	}};
	border-left: 1px solid ${({ hasError }) => (hasError ? helpers.color.input.menuSeparatorError : helpers.color.input.menuSeparator)};
	flex-shrink: 0;
`
